import React, {Component} from 'react';
import "./MidiSupportWarning.css";

export class MidiSupportWarning extends Component {

    state = {
        supported: true
    };

    componentDidMount() {
        if (!navigator.requestMIDIAccess) {
            this.setState({supported: false});
        }
    }

    render() {

        if (this.state.supported) return null;

        return (
            <div className="midi-support-warning-top">
                This browser does not support MIDI.
                See <a href="https://developer.mozilla.org/en-US/docs/Web/API/MIDIAccess#Browser_compatibility" target="_blank" rel="noreferrer noopener">the official WebMIDI compatibility page</a> for a list of browsers that support MIDI.
            </div>
        );

    }

}
